export default "__VITE_ASSET__D3u2egNn__"